import React from "react";

/** Mirrors backend OrderRefundStatus (constants/status.js). */
export enum OrderRefundStatus {
	Idle = 1,
	Begin = 2,
	Done = 3,
	Terminated = 4,
}

/** Second chip under "Cancelled" — admin only; stations keep seeing just "Cancelled". */
const MAP: Record<number, { label: string; color: string; bg: string; title: string }> = {
	[OrderRefundStatus.Done]: {
		label: "Refunded",
		color: "#047857",
		bg: "#D1FAE5",
		title: "Money returned to the customer via the payment gateway",
	},
	[OrderRefundStatus.Begin]: {
		label: "Refund pending",
		color: "#B45309",
		bg: "#FEF3C7",
		title: "Refund sent to the gateway, waiting for confirmation",
	},
	[OrderRefundStatus.Terminated]: {
		label: "Refund failed",
		color: "#B91C1C",
		bg: "#FEE2E2",
		title: "Gateway rejected the refund — refund manually",
	},
	[OrderRefundStatus.Idle]: {
		label: "No refund",
		color: "#475569",
		bg: "#F1F5F9",
		title: "Cancelled without refunding the customer",
	},
};

export default function CancelledRefundBadge(props: { refundStatus?: number | null }) {
	const m = MAP[Number(props.refundStatus)] || MAP[OrderRefundStatus.Idle];
	return (
		<div
			title={m.title}
			style={{
				display: "inline-block",
				marginTop: 6,
				padding: "2px 8px",
				borderRadius: 999,
				fontSize: 12,
				fontWeight: 600,
				color: m.color,
				background: m.bg,
				whiteSpace: "nowrap",
			}}>
			{m.label}
		</div>
	);
}
